import { useEffect, useRef, useState } from "react";
import { useLazyGetCollectionsListPageQuery } from "../collections/collectionsApi";

const PAGE_SIZE = 200;
const MAX_PAGES = 25; // same 5000-row safety cap Flutter's own pagination loop uses

// Pages through GET /collections until it runs out of rows (or hits the
// cap), for the Collections Dashboard Section's per-branch detail and
// Post-Dated-Cheques/Cheques-Due-Today figures - there's no server-side
// groupBy for those dimensions, same reason Flutter's own dashboard
// aggregates client-side off this same paginated endpoint.
export const useCollectionsRecords = (params, { skip = false } = {}) => {
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [trigger] = useLazyGetCollectionsListPageQuery();
  const paramsKey = JSON.stringify(params);
  const requestId = useRef(0);

  useEffect(() => {
    if (skip) return;
    const thisRequest = ++requestId.current;

    (async () => {
      setIsLoading(true);
      const collected = [];
      for (let page = 1; page <= MAX_PAGES; page += 1) {
        const result = await trigger({ ...params, page, pageSize: PAGE_SIZE }).unwrap();
        if (thisRequest !== requestId.current) return; // a newer request superseded this one
        collected.push(...(result.items || []));
        if (collected.length >= result.totalCount || (result.items || []).length < PAGE_SIZE) break;
      }
      if (thisRequest === requestId.current) {
        setRows(collected);
        setIsLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paramsKey, skip]);

  return { rows, isLoading };
};
